<template>
  <div class="SectionTwo" :style="{backgroundImage: `url(${ASSETS_BASE_URL}/images/home/backdrop_1.jpg)`}">
    <div class="uk-container">
      <div uk-grid>
        <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s DetailsConTwo">
          <h1 class="uk-text-center uk-text-middle AppTitle Title" data-aos="zoom-in" data-aos-delay="100">
            {{'home_section.title_1'|translate}}
          </h1>
        </div>
        <div class="uk-width-1-1@l uk-width-1-1@m  uk-width-1-1@s uk-grid-small" uk-grid>
          <div class="uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s" data-aos="fade-up">
            <router-link to="/casamia-nilaveli">
              <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
                <div class="uk-cover-container">
                  <canvas height="350"></canvas>
                  <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_1.jpg`" alt="" uk-cover>
                  <div class="uk-overlay uk-overlay-default uk-position-center HotelLogoCon">
                    <img class="HotelLogo" :src="`${ASSETS_BASE_URL}/images/home/hotel_nilaveli.png`" alt=""/>
                  </div>
                  <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                    <p>CASAMIA Nilaveli</p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="uk-width-1-2@l uk-width-1-2@m uk-width-1-1@s" data-aos="fade-up" data-aos-delay="50">
            <router-link to="/casamia-colombo">
              <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
                <div class="uk-cover-container">
                  <canvas height="350"></canvas>
                  <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_3.jpg`" alt="" uk-cover>
                  <div class="uk-overlay uk-overlay-default uk-position-center HotelLogoCon">
                    <img class="HotelLogo" :src="`${ASSETS_BASE_URL}/images/home/hotel_colombo.png`" alt=""/>
                  </div>
                  <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                    <p>CASAMIA Colombo</p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="uk-width-1-1@l uk-width-1-1@m uk-width-1-1@s" data-aos="fade-up" data-aos-delay="100">
            <router-link to="/turtle-nest">
              <div class="uk-card uk-card-default uk-card-body uk-padding-remove">
                <div class="uk-cover-container">
                  <canvas height="350"></canvas>
                  <img class="HotelBackdrop" :src="`${ASSETS_BASE_URL}/images/home/img_5.jpg`" alt="" uk-cover>
                  <div class="uk-overlay uk-overlay-default uk-position-center HotelLogoCon">
                    <img class="HotelLogo" :src="`${ASSETS_BASE_URL}/images/home/logo_homewind.png`" alt=""/>
                  </div>
                  <div class="uk-overlay uk-light uk-position-bottom CanvasDetails">
                    <p>Turtle Nest Rekawa</p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeSectionTwo'
}
</script>

<style scoped>
  .SectionTwo {
    padding-top: 0;
    padding-bottom: 80px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-blend-mode: color-burn;
    background-color: #ffffffd9;
  }

  .DetailsConTwo {
    padding-top: 40px;
  }

  .CanvasDetails {
    background: #00000073;
    color: #FFF;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .HotelBackdrop {
    /*-webkit-filter: blur(3px);*/
    /*filter: blur(3px);*/
  }

  .HotelLogoCon {
    padding: 15px;
    background: none;
    border-radius: 3px;
    top: 40px;
    left: 110px;
  }

  .HotelLogo {
    width: 200px;
  }

  @media only screen and (max-width: 959px) {
    .SectionTwo {
      padding-bottom: 0;
    }
  }
</style>
